import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadinessPharma from "@/pages/EuReadinessPharma";

export const Route = createFileRoute("/en/eu-readiness-pharma")({
  head: () => buildRouteHead("/en/eu-readiness-pharma"),
  component: EuReadinessPharma,
});

